import utils from 'analytics/utils';
import analyticsConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';
import deepExtend from 'utils/deepExtend';
import skuUtils from 'utils/Sku';
import userUtils from 'utils/User';

export default function (data) {
    const currentEvent = utils.getMostRecentEvent(analyticsConsts.LINK_TRACKING_EVENT);

    const existingProductString = currentEvent.eventInfo.attributes.productStrings;

    const flashSkuId = skuUtils.IDs.FLASH;

    let newProductString;

    let internalCampaign;

    const eventStrings = currentEvent.eventInfo.attributes.eventStrings;

    if (userUtils.getBiStatus() === userUtils.types.ROUGE) {
        internalCampaign = 'flash product+flash:enroll in flash';

        newProductString = existingProductString.concat('|eVar72=product');
    } else {
        internalCampaign = 'flash product+flash:add to basket';

        const pPageSkuId = anaUtils.safelyReadProperty('skuList.0.skuId', data);

        newProductString = existingProductString
            .concat(`;${pPageSkuId};;;;eVar26=${pPageSkuId}|eVar72=product:flash`)
            .concat(`;${flashSkuId};;;;eVar26=${flashSkuId}|eVar72=product:flash`);
    }

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                actionInfo: '',
                productStrings: newProductString,
                internalCampaign,
                eventStrings
            }
        }
    });
}
